import BaseService from './BaseService'

class RoleService extends BaseService {

  constructor () {
    super({path: 'roles', entity: 'role'})
  }

  attachPermission (roleId, data) {
    return this.instance.post(`/${roleId}/permissions`, data)
  }

  detachPermission (roleId, data) {
    return this.instance.delete(`/${roleId}/permissions/`, {
      data
    })
  }

}

export default new RoleService()
